import { render, staticRenderFns } from "./GroupRegainsubMatrixPhone.vue?vue&type=template&id=16a7aacd&scoped=true&"
import script from "./GroupRegainsubMatrixPhone.vue?vue&type=script&lang=js&"
export * from "./GroupRegainsubMatrixPhone.vue?vue&type=script&lang=js&"
import style0 from "./GroupRegainsubMatrixPhone.vue?vue&type=style&index=0&id=16a7aacd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a7aacd",
  null
  
)

export default component.exports